import { UPDATE_FRONT_STYLE_ONSTREET_COMMON } from "./frontStyleOnstreetCommonReducer"

export const updateFrontStyleOnstreetCommon = (status) => ({
    type: UPDATE_FRONT_STYLE_ONSTREET_COMMON,
    payload: status
})
